import React, { FunctionComponent } from 'react';
import ChangeModel from '../../changeModel/ChangeModel';
import customise from '../../../../../constants/customise';
import VariantSelectorBase from '../variantSelectorBase/VariantSelectorBase';
import useVariants from '../../../../../../gqlCommon/hooks/queries/useVariants';
import useMarketingCategories from '../../../../../hooks/useMarketingCategories';
import VariantListContainer from '../variantList/VariantListContainer';
import VariantCategoryTabsContainer from '../variantList/VariantCategoryTabsContainer';

export interface IVariantContainerProps {
  selectedVariantId: string;
  changeVariant: (variantId: string) => void;
}

const VariantContainer: FunctionComponent<IVariantContainerProps> = ({ selectedVariantId, changeVariant }) => {
  const variantName = customise.VARIANT_ITEM.name;
  const { trimData, variantsData, loading: isLoadingVariants, error } = useVariants();
  const variants = variantsData || [];
  const { marketingCategories, setMarketingCategory, selectedMarketingCategory } = useMarketingCategories(variants);
  const model = trimData?.label;

  return (
    <VariantSelectorBase sectionName={variantName} error={error}>
      <ChangeModel variant={'caption'} align={'left'} />
      <VariantCategoryTabsContainer
        setMarketingCategory={setMarketingCategory}
        selectedMarketingCategory={selectedMarketingCategory}
        marketingCategories={marketingCategories}
      />
      <VariantListContainer
        selectedMarketingCategory={selectedMarketingCategory}
        selectedVariantId={selectedVariantId}
        changeVariant={changeVariant}
        variants={variants}
        model={model}
        isLoadingVariants={isLoadingVariants}
      />
    </VariantSelectorBase>
  );
};

export default VariantContainer;
